/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FlightTestOffer } from "./FlightTestOffer";
import {
  FlightTestOfferFromJSON,
  FlightTestOfferFromJSONTyped,
  FlightTestOfferToJSON,
  FlightTestOfferToJSONTyped,
} from "./FlightTestOffer";
import type { FlightPointsOnlyOffer } from "./FlightPointsOnlyOffer";
import {
  FlightPointsOnlyOfferFromJSON,
  FlightPointsOnlyOfferFromJSONTyped,
  FlightPointsOnlyOfferToJSON,
  FlightPointsOnlyOfferToJSONTyped,
} from "./FlightPointsOnlyOffer";
import type { Offer } from "./Offer";
import {
  OfferFromJSON,
  OfferFromJSONTyped,
  OfferToJSON,
  OfferToJSONTyped,
} from "./Offer";
import type { GoogleFlightOffer } from "./GoogleFlightOffer";
import {
  GoogleFlightOfferFromJSON,
  GoogleFlightOfferFromJSONTyped,
  GoogleFlightOfferToJSON,
  GoogleFlightOfferToJSONTyped,
} from "./GoogleFlightOffer";
import type { FlightSearchStatus } from "./FlightSearchStatus";
import {
  FlightSearchStatusFromJSON,
  FlightSearchStatusFromJSONTyped,
  FlightSearchStatusToJSON,
  FlightSearchStatusToJSONTyped,
} from "./FlightSearchStatus";
import type { FlightSearchErrorDetail } from "./FlightSearchErrorDetail";
import {
  FlightSearchErrorDetailFromJSON,
  FlightSearchErrorDetailFromJSONTyped,
  FlightSearchErrorDetailToJSON,
  FlightSearchErrorDetailToJSONTyped,
} from "./FlightSearchErrorDetail";

/**
 * The response for a flight search
 * @export
 * @interface FlightSearchResponse
 */
export interface FlightSearchResponse {
  /**
   * Supplier credential mode confirmed by this server. Test consumers must require true.
   * @type {boolean}
   * @memberof FlightSearchResponse
   */
  test?: boolean;
  /**
   *
   * @type {Array<FlightTestOffer>}
   * @memberof FlightSearchResponse
   */
  testOffers?: Array<FlightTestOffer>;
  /**
   * Required typed outcome for this search. The producer rollout is complete and every API Search return path emits this field, so consumers can distinguish legitimate empty results from invalid requests and provider failures.
   * @type {FlightSearchStatus}
   * @memberof FlightSearchResponse
   */
  status: FlightSearchStatus;
  /**
   *
   * @type {FlightSearchErrorDetail}
   * @memberof FlightSearchResponse
   */
  errorDetail?: FlightSearchErrorDetail;
  /**
   *
   * @type {Array<Offer>}
   * @memberof FlightSearchResponse
   */
  items?: Array<Offer>;
  /**
   * Which backend actually served this response. Acts as a discriminator: when "duffel", read `items`; when "google_flights", read `google_flights_offers` and `search_url`. A google_flights request that fell back returns "duffel".
   * @type {string}
   * @memberof FlightSearchResponse
   */
  provider?: FlightSearchResponseProviderEnum;
  /**
   * "View on Google Flights" link for the route (google_flights provider only).
   * @type {string}
   * @memberof FlightSearchResponse
   */
  searchUrl?: string;
  /**
   * Cash-priced itineraries scraped from the Google Flights results page. Populated only when `provider` is "google_flights". Not bookable (display + link only).
   * @type {Array<GoogleFlightOffer>}
   * @memberof FlightSearchResponse
   */
  googleFlightsOffers?: Array<GoogleFlightOffer>;
  /**
   * Identifies this search so award pricing can be collected afterwards via `GET /search/flights/{search_id}/points`. Populated for every caller.
   * @type {string}
   * @memberof FlightSearchResponse
   */
  searchId?: string;
  /**
   * Award-pricing state of this response. "complete": every program we have an answer for is answered and nothing is outstanding. "partial": some answered, others are still being scraped. "pending": none answered yet, scrapes are in flight. "none": no award pricing is available on this response and none is coming — either it was not requested, or this is a round-trip search (never award-priced), or every scrape failed to start. Those cases are deliberately one value: the caller's action is the same in all of them, which is not to call the enrichment endpoint. Distinguish them in metrics (`flight_points_dispatch_fire_and_forget{success="False"}`), not here. Populated for every caller.
   * @type {string}
   * @memberof FlightSearchResponse
   */
  pointsStatus?: FlightSearchResponsePointsStatusEnum;
  /**
   * Programs whose award pricing is already attached to the offers above, served from cache. MCP callers only; null otherwise.
   * @type {Array<string>}
   * @memberof FlightSearchResponse
   */
  resolvedSources?: Array<string>;
  /**
   * Programs still being scraped. Pass these back to `GET /search/flights/{search_id}/points` to collect the results — that endpoint has no other way to know which programs were dispatched. MCP callers only; null otherwise.
   * @type {Array<string>}
   * @memberof FlightSearchResponse
   */
  pendingSources?: Array<string>;
  /**
   * Award inventory already in cache that prices none of the itineraries in `google_flights_offers` — award seats Google Flights did not return. Delivered here rather than by `GET /search/flights/{search_id}/points`, which can only report what a scrape it dispatched returned: a cache hit dispatches nothing, its rows carry an earlier `search_id`, and `points_status` is `complete`, so there is no second call these could arrive on. Programs still being scraped return their own award-only inventory from that endpoint instead. MCP callers only; null otherwise, and empty when an MCP search found none.
   * @type {Array<FlightPointsOnlyOffer>}
   * @memberof FlightSearchResponse
   */
  pointsOnly?: Array<FlightPointsOnlyOffer>;
}

/**
 * @export
 */
export const FlightSearchResponseProviderEnum = {
  Duffel: "duffel",
  GoogleFlights: "google_flights",
} as const;
export type FlightSearchResponseProviderEnum =
  (typeof FlightSearchResponseProviderEnum)[keyof typeof FlightSearchResponseProviderEnum];

/**
 * @export
 */
export const FlightSearchResponsePointsStatusEnum = {
  Complete: "complete",
  Partial: "partial",
  Pending: "pending",
  None: "none",
} as const;
export type FlightSearchResponsePointsStatusEnum =
  (typeof FlightSearchResponsePointsStatusEnum)[keyof typeof FlightSearchResponsePointsStatusEnum];

/**
 * Check if a given object implements the FlightSearchResponse interface.
 */
export function instanceOfFlightSearchResponse(
  value: object
): value is FlightSearchResponse {
  if (!("status" in value) || value["status"] === undefined) return false;
  return true;
}

export function FlightSearchResponseFromJSON(json: any): FlightSearchResponse {
  return FlightSearchResponseFromJSONTyped(json, false);
}

export function FlightSearchResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightSearchResponse {
  if (json == null) {
    return json;
  }
  return {
    test: json["test"] == null ? undefined : json["test"],
    testOffers:
      json["test_offers"] == null
        ? undefined
        : (json["test_offers"] as Array<any>).map(FlightTestOfferFromJSON),
    status: FlightSearchStatusFromJSON(json["status"]),
    errorDetail:
      json["error_detail"] == null
        ? undefined
        : FlightSearchErrorDetailFromJSON(json["error_detail"]),
    items:
      json["items"] == null
        ? undefined
        : (json["items"] as Array<any>).map(OfferFromJSON),
    provider: json["provider"] == null ? undefined : json["provider"],
    searchUrl: json["search_url"] == null ? undefined : json["search_url"],
    googleFlightsOffers:
      json["google_flights_offers"] == null
        ? undefined
        : (json["google_flights_offers"] as Array<any>).map(
            GoogleFlightOfferFromJSON
          ),
    searchId: json["search_id"] == null ? undefined : json["search_id"],
    pointsStatus:
      json["points_status"] == null ? undefined : json["points_status"],
    resolvedSources:
      json["resolved_sources"] == null ? undefined : json["resolved_sources"],
    pendingSources:
      json["pending_sources"] == null ? undefined : json["pending_sources"],
    pointsOnly:
      json["points_only"] == null
        ? undefined
        : (json["points_only"] as Array<any>).map(
            FlightPointsOnlyOfferFromJSON
          ),
  };
}

export function FlightSearchResponseToJSON(json: any): FlightSearchResponse {
  return FlightSearchResponseToJSONTyped(json, false);
}

export function FlightSearchResponseToJSONTyped(
  value?: FlightSearchResponse | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    test: value["test"],
    test_offers:
      value["testOffers"] == null
        ? undefined
        : (value["testOffers"] as Array<any>).map(FlightTestOfferToJSON),
    status: FlightSearchStatusToJSON(value["status"]),
    error_detail: FlightSearchErrorDetailToJSON(value["errorDetail"]),
    items:
      value["items"] == null
        ? undefined
        : (value["items"] as Array<any>).map(OfferToJSON),
    provider: value["provider"],
    search_url: value["searchUrl"],
    google_flights_offers:
      value["googleFlightsOffers"] == null
        ? undefined
        : (value["googleFlightsOffers"] as Array<any>).map(
            GoogleFlightOfferToJSON
          ),
    search_id: value["searchId"],
    points_status: value["pointsStatus"],
    resolved_sources: value["resolvedSources"],
    pending_sources: value["pendingSources"],
    points_only:
      value["pointsOnly"] == null
        ? undefined
        : (value["pointsOnly"] as Array<any>).map(FlightPointsOnlyOfferToJSON),
  };
}
